module.exports = __webpack_public_path__ + "media/images/slide-14-e89b14a82e9cc311a4f9c17c8febd5a5.jpg";